import { render, staticRenderFns } from "./List.vue?vue&type=template&id=a1510536&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=a1510536&prod&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=a1510536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1510536",
  null
  
)

export default component.exports